// extracted by mini-css-extract-plugin
export default {"bank":"Bank_bank__2DdsZ","selectorWrapper":"Bank_selectorWrapper__MIdca","option":"Bank_option__qvCyl","selectorCurrentItem":"Bank_selectorCurrentItem__Qennz"};